import { Navigate, Outlet, useLocation } from "react-router";

import { GUEST_ONLY_ROUTES } from "@/constants/routes";
import { useAppSelector } from "@/store/hooks";

/**
 * docs/ui/routes.md's Protected/Admin redirect rule: "Redirect to
 * `/login?redirect=<original path>`; on successful login, redirect to
 * `<original path>` instead of the default `/`." `LoginPage` reads that
 * `redirect` param back out — see its `onSuccess` handler.
 *
 * This only checks *authenticated or not* — it doesn't check role, so it's
 * also what `AdminLayout`'s routes use today (docs/ui/routes.md: an
 * unauthenticated user hitting an admin route redirects to `/login`, same
 * as any other protected route). A `RequireRole` layer for
 * Admin/Moderator/Super Admin gets added once those roles exist in the auth
 * model (docs/architecture/authentication.md currently only has
 * Guest/User) — not stubbed in now with no role to check.
 */
export function RequireAuth() {
  const status = useAppSelector((state) => state.auth.status);
  const location = useLocation();

  if (status !== "authenticated") {
    const redirect = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`${GUEST_ONLY_ROUTES.login}?redirect=${redirect}`} replace />;
  }

  return <Outlet />;
}
